import { CommonDirection } from 'shared/entities/common/client';

export type TrendDirection = CommonDirection.top | CommonDirection.bottom;

export const trendDefaultColors: Record<TrendDirection, string> = {
  [CommonDirection.top]: '#129a5a',
  [CommonDirection.bottom]: '#d2362a'
};
